'use client'

import { useState } from 'react'
import Counter from 'react-countup'

import { StatsBlockSb } from '@/components/findex-connect/types/component-types-sb'

type StatCounterProps = {
  data: StatsBlockSb['statistics']
  duration?: number
}

export const StatCounter: React.FC<StatCounterProps> = ({ data, duration = 4 }) => {
  const [showSuffix, setShowSuffix] = useState(false)
  return (
    <div className="STATCOUNTER w-full">
      <div className="COUNTER-CONTAINER flex flex-col gap-6 md:flex-row md:flex-wrap md:gap-0">
        {data?.map(({ label, value, prefix, suffix }, index) => {
          const number = Number(value)
          return (
            <div
              key={`${index}-${label}`}
              className="COUNTER-ITEM flex min-w-[250px] shrink-0 grow-0 basis-[23%] flex-col items-start justify-between border-b border-black/10 px-4 md:my-4 md:h-[172px] md:border-b-0 md:border-l"
            >
              <p className="textblock-md text-text mb-4">{label}</p>
              <div className="DATA-VALUE text-primary-dark text-48 mb-2 flex items-center gap-2 text-5xl md:mb-0">
                <Counter
                  prefix={prefix}
                  className={``}
                  end={number}
                  duration={duration}
                  enableScrollSpy={true}
                  scrollSpyOnce
                  separator=","
                  onEnd={() => setShowSuffix(true)}
                />
                {suffix && (
                  <span
                    className={
                      `transition-all duration-[2s] ease-in-out ` +
                      (showSuffix ? ` opacity-100` : ` opacity-0`) +
                      (suffix === '+' ? ` ml-[-6px]` : '')
                    }
                  >
                    {suffix}
                  </span>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
